import { io, Socket } from 'socket.io-client';
import { getAccessToken } from './token';

type Connection = { socket: Socket; users: number };
let connection: Connection | undefined;

// Notifications and the open lead share a single connection per browser tab.
export const acquireRealtimeConnection = () => {
  if (!connection) connection = {
    socket: io({ auth: (callback) => callback({ token: getAccessToken() }) }),
    users: 0,
  };
  const current = connection;
  current.users++;
  let released = false;
  return {
    socket: current.socket,
    release: () => {
      if (released) return;
      released = true;
      if (--current.users === 0) {
        current.socket.disconnect();
        if (connection === current) connection = undefined;
      }
    },
  };
};
